export const checkCondition = (condition, data) => {
  if (!data) return false;
  // For multi-field OR conditions
  // this is AND condition for a temporary measure
  if (Array.isArray(condition)) {
    return condition.every((option) => {
      const conditionData = data[option.field];
      if (Array.isArray(option.value)) {
        return option.value.includes(conditionData);
      }
      return conditionData === option.value;
    });
    // return condition.some((option) => {
    //   const conditionData = data[option.field];
    //   if (!conditionData) return false;
    //   return conditionData === option.value;
    // });
  }
  // Single-field conditions
  const conditionData = data[condition.field];
  if (Array.isArray(condition.value)) {
    return condition.value.includes(conditionData);
  }
  return conditionData === condition.value;
};

export const isConditionLocal = (condition) => {
  // For multi-field OR conditions
  if (Array.isArray(condition)) {
    // Ideally, we want all conditional fields to depend either on all local fields or all external fields
    return condition.some((option) => option.isLocal);
  }
  // Single-field conditions
  return condition.isLocal;
};

/**
 * This function checks the conditions in form schema or section schemas
 * and returns only the sections or questions that satisfy the conditions
 *
 * @param {Object} schema - form or section schema object to be filtered
 * @param {Object} flatData - data from the DB in a flat object ("data vault")
 *
 */
export const filterSchema = (schema, flatData) => {
  if (!flatData) return schema;
  if (!Array.isArray(schema)) return schema;

  // Filter sections that have conditions based on DB data
  return schema.filter((item) => {
    if (item.condition) {
      const isLocal = isConditionLocal(item.condition);

      // If condition refers to a field within the same section, don't filter it out;
      // It will be evaulated against neighbouring fields in InputTypeSwitch
      if (isLocal) {
        return true;
      }

      // If condition refers to a field from another section or another form,
      // evaluate it against the DB data
      return checkCondition(item.condition, flatData);
    }
    return true;
  });
};
